<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->
<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.043 15.4571L19.629 14.0431L17.129 16.7151L15.983 15.5691L18.044 13.5081L16.63 12.0941L14.569 14.1551L11.21 10.7961L11.515 10.1591C12.426 8.25006 12.035 5.96406 10.543 4.47206C8.59099 2.52006 5.41899 2.52006 3.46999 4.47006C1.52099 6.41906 1.52099 9.59206 3.46999 11.5411C4.96199 13.0331 7.24799 13.4241 9.15699 12.5131L9.79399 12.2081L18.543 20.9571L19.957 19.5431L18.543 18.1291L21.043 15.4571ZM9.12699 10.1271C7.95699 11.2971 6.05399 11.2971 4.88399 10.1271C3.71399 8.95706 3.71399 7.05406 4.88399 5.88406C6.05399 4.71406 7.95699 4.71406 9.12699 5.88406C10.296 7.05406 10.296 8.95706 9.12699 10.1271Z"
    />
  </g>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
